declare const Phaser: any;

export function spawnAsteroid(
  scene: any,
  asteroids: any,
  size: string,
  w: number,
  h: number,
  x?: number,
  y?: number
) {
  if (x === undefined) {
    const edge = Phaser.Math.Between(0, 3);
    if (edge === 0) { x = 0; y = Phaser.Math.Between(0, h); }
    else if (edge === 1) { x = w; y = Phaser.Math.Between(0, h); }
    else if (edge === 2) { x = Phaser.Math.Between(0, w); y = 0; }
    else { x = Phaser.Math.Between(0, w); y = h; }
  }

  const ast = asteroids.create(x, y, size);
  ast.setData("size", size);

  const speed = size === "ast-lg" ? 60 : size === "ast-md" ? 100 : 140;
  const angle = Phaser.Math.FloatBetween(0, Math.PI * 2);
  scene.physics.velocityFromRotation(angle, speed, ast.body.velocity);
  ast.setAngularVelocity(Phaser.Math.Between(-100, 100));
  ast.setBounce(1);
  ast.setCollideWorldBounds(true);

  const r = size === "ast-lg" ? 24 : size === "ast-md" ? 14 : 8;
  ast.body.setCircle(r);
}
